// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--e5cda";
export var headingContainer = "index-module--heading-container--ae9e3";
export var highlight = "index-module--highlight--f67de";
export var highlightLine = "index-module--highlight-line--40255";
export var image1 = "index-module--image-1--5ae0d";
export var image2 = "index-module--image-2--6363e";
export var imageContainer = "index-module--image-container--6728e";